module.exports = __webpack_public_path__ + "img/bg_inhalt.0981e734.jpg";